import { render } from "./risk_questionnaire.html?vue&type=template&id=6b02e95c&external"
import script from "./risk_questionnaire.js?vue&type=script&lang=js&external"
export * from "./risk_questionnaire.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__